import { appRouterConfigFn } from '@core/router/app-router-config';
import { APP, DELIVERIES, LOGIN, BILLING, ERROR, ERROR_NOTFOUND, ERROR_RESTRICTED, DEVSUPPORT, LOCATIONS, REGISTRATION, PROFILE, LIVEVIEW, REPORTS } from '@core/router/app-states';
import { AppLoaderComponent } from '@shell/ui/app-loader/app-loader.component';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { AppComponent } from './app.component';
import { environment } from '@environments/environment';
import { NotFoundComponent } from '@components/not-found/not-found.component';

const APP_STATES: Ng2StateDeclaration[] = [
    {
        name: APP,
        url: '',
        views: {
            '@': {
                component: AppComponent,
            },
        },
        redirectTo: {
            state: environment.paths.home.employer.state
        }
    },
    {
        name:`${ LOGIN }.**`,
        url: `/${ LOGIN }`,
        loadChildren: () => import('./features/login/login.module').then((module) =>  module.LoginModule)
    },
    {
        name: `${ LIVEVIEW }.**`,
        url: `/${ LIVEVIEW }`,
        loadChildren: () => import('./features/live-view/live-view.module').then((module) => module.LiveViewModule)
    },
    {
        name: `${ DELIVERIES }.**`,
        url: `/${ DELIVERIES }`,
        loadChildren: () => import('./features/deliveries/deliveries.module').then((module) => module.DeliveriesModule)
    },
    {
        name: `${ DEVSUPPORT }.**`,
        url: `/${ DEVSUPPORT }`,
        loadChildren: () => import('./features/dev-support/dev-support.module').then((module) => module.DevSupportModule)
    },
    {
        name: `${ REPORTS }.**`,
        url: `/${ REPORTS }`,
        loadChildren: () => import('./features/reports/reports.module').then((module) => module.ReportsModule)
    },
    {
        name: `${ BILLING }.**`,
        url: `/${ BILLING }`,
        loadChildren: () => import('./features/billing/billing.module').then((module) => module.BillingModule)
    },
    {
        name: `${ LOCATIONS }.**`,
        url: `/${ LOCATIONS }`,
        loadChildren: () => import('./features/locations/locations.module').then((module) => module.LocationsModule)
    },
    {
        name: `${ PROFILE }.**`,
        url: `/${ PROFILE }`,
        loadChildren: () => import('./features/profile/profile.module').then((module) => module.ProfileModule)
    },
    {
        name: `${ REGISTRATION }.**`,
        url: `/signup`,
        loadChildren: () => import('./features/registration/registration.module').then((module) => module.RegistrationModule)
    },
    {
        name: `${ ERROR }`,
        url: `/${ ERROR }`,
        abstract: true,
        redirectTo: {
            state: ERROR_NOTFOUND,
        },
    },
    {
        name: `${ ERROR_NOTFOUND }`,
        url: '/404',
        views: {
            '@': {
                component: NotFoundComponent,
            },
        },
    },
    {
        name: `${ ERROR_RESTRICTED }`,
        url: '/restricted',
        views: {
            '@': {
                component: NotFoundComponent,
            },
        },
    },
    {
        name: 'empty', url: '/', redirectTo: 'app'
    }
];

export const appRoutes = UIRouterModule.forRoot({
    states: APP_STATES,
    otherwise: '/error/404',
    useHash: true,
    config: appRouterConfigFn,
});
